import React, { useState } from 'react';
import { PhoneInput } from 'react-international-phone';
// import HuiToggle from '../HuiToggle/HuiToggle';
import './HuiPhoneInput.css';
import 'react-international-phone/style.css';

interface PhoneInputProps {
  invalid: boolean;
  placeholder: string;
  disabled?: boolean;
  onSwitchChange?: () => void;
  switchValue?: boolean;
  value: string;
  onChange: (value: string, name: string) => void;
  name: string;
}

const HuiPhoneInput: React.FC<PhoneInputProps> = ({ 
  invalid,
  placeholder, 
  disabled, 
  onSwitchChange, 
  switchValue,
  value,
  onChange,
  name
}) => {
  const [isFocused, setIsFocused] = useState(false);

  const handleInputChange = (phone: string) => {
    onChange(phone, name);
  };

  return (
    <div style={{ position: 'relative', flex: '0 49%', width: '100%' }}>
      <div className={`hui-input-field-phone ${disabled ? 'disabled' : ''} ${invalid ? 'invalid' : ''}`}>
      <PhoneInput
        onFocus={() => {
          setIsFocused(true);
          if (!value) handleInputChange('');
        }}
        onBlur={() => {
          setIsFocused(false);
          if (value === '') handleInputChange('');
        }}
        value={value}
        onChange={handleInputChange}
        disabled={disabled}
        defaultCountry='us'
        className="hui-input-phone"
        inputStyle={{
          fontFamily: 'NHaasGroteskTXPro-55Rg',
          fontSize: '17px',
          border: 'none',
          outline: 'none',
          background: 'none',
          padding: '0',
        }}
      />
      <label className={`hui-label-phone ${value || isFocused ? 'filled' : ''}`}>{placeholder}</label>
      {/* <HuiToggle isOn={switchValue} handleToggle={onSwitchChange} /> */}
    </div>
    {invalid && <div className="error-message">Your phone number validation failed.</div>}
    </div>
   
  );
};

export default HuiPhoneInput;